import { render } from "./NewsPage.vue?vue&type=template&id=c31202b8&scoped=true&ts=true"
import script from "./NewsPage.vue?vue&type=script&lang=ts"
export * from "./NewsPage.vue?vue&type=script&lang=ts"

import "./NewsPage.vue?vue&type=style&index=0&id=c31202b8&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31202b8"]])

export default __exports__